var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsColorSelectionIcon = function SvgDsColorSelectionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.417 3.875a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0M5 5.25a.667.667 0 1 1-1.333 0A.667.667 0 0 1 5 5.25M11.167 5.917a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M12.958 8.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0M10.458 12.292a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.28.672a7.33 7.33 0 0 0-7.613 7.33 2.96 2.96 0 0 0 3.74 2.857h.003l.531-.148-.176-.643.178.643h-.001a.76.76 0 0 1 .96.736v1.792a2.095 2.095 0 0 0 2.095 2.094 7.33 7.33 0 0 0 7.33-7.613v-.002A7.354 7.354 0 0 0 8.283.672zm-2.417 1.72a6 6 0 0 1 2.365-.388 6.02 6.02 0 0 1 5.768 5.768A6 6 0 0 1 7.998 14a.76.76 0 0 1-.762-.761v-1.79A2.094 2.094 0 0 0 4.59 9.425h-.002l-.531.148h-.001A1.628 1.628 0 0 1 2 8.002a6 6 0 0 1 3.863-5.61m1.373 9.057H6.57l.667.001m6.76-3.677.666-.027z",
    clipRule: "evenodd"
  })));
};
export default SvgDsColorSelectionIcon;